import registrationStyles from '../../styles';

export default {
  ...registrationStyles,
  subTitle: {
    fontSize: '24px',
  },
};
